var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4"},[_c('v-card-title',{staticClass:"headline"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_c('apexchart',{attrs:{"type":"bar","height":"360","options":_vm.options,"series":_vm.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }